// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { NormalService, NormalServiceT } from "./normal-service";
import { ValuedService, ValuedServiceT } from "./valued-service";

export enum ServiceVariant {
  NONE = 0,
  NormalService = 1,
  ValuedService = 2,
}

export function unionToServiceVariant(
  type: ServiceVariant,
  accessor: (obj: NormalService | ValuedService) => NormalService | ValuedService | null,
): NormalService | ValuedService | null {
  switch (ServiceVariant[type]) {
    case "NONE":
      return null;
    case "NormalService":
      return accessor(new NormalService())! as NormalService;
    case "ValuedService":
      return accessor(new ValuedService())! as ValuedService;
    default:
      return null;
  }
}

export function unionListToServiceVariant(
  type: ServiceVariant,
  accessor: (
    index: number,
    obj: NormalService | ValuedService,
  ) => NormalService | ValuedService | null,
  index: number,
): NormalService | ValuedService | null {
  switch (ServiceVariant[type]) {
    case "NONE":
      return null;
    case "NormalService":
      return accessor(index, new NormalService())! as NormalService;
    case "ValuedService":
      return accessor(index, new ValuedService())! as ValuedService;
    default:
      return null;
  }
}

export type ServiceVariantT =
  | { type: "NONE"; value: null }
  | { type: "NormalService"; value: NormalServiceT }
  | { type: "ValuedService"; value: ValuedServiceT };
